import { render, staticRenderFns } from "./RejectReasonWizard.vue?vue&type=template&id=5f72961c&scoped=true"
import script from "./RejectReasonWizard.vue?vue&type=script&lang=js"
export * from "./RejectReasonWizard.vue?vue&type=script&lang=js"
import style0 from "./RejectReasonWizard.vue?vue&type=style&index=0&id=5f72961c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72961c",
  null
  
)

export default component.exports